export default __webpack_public_path__ + "static/media/feature4_1.8524a933.png";